import { render, staticRenderFns } from "./uploadModal_tea.vue?vue&type=template&id=91ecd14e&scoped=true&"
import script from "./uploadModal_tea.vue?vue&type=script&lang=js&"
export * from "./uploadModal_tea.vue?vue&type=script&lang=js&"
import style0 from "./uploadModal_tea.vue?vue&type=style&index=0&id=91ecd14e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ecd14e",
  null
  
)

export default component.exports